import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Brain, Cpu, Network, Zap, Code, RefreshCw } from 'lucide-react';
import logo from '../../../assets/ngsonlylogo.png'; // Adjust the path to your logo file
import Header from './Header';
import about from  '../../../assets/icon/about.svg';

export default function AboutUs() {
  const [animateParticles, setAnimateParticles] = useState(true);
  const [hoveredCard, setHoveredCard] = useState(null);
  
  // AI-focused feature cards
  const featureCards = [
    {
      icon: <Brain className="mb-4 text-purple-500" size={28} />,
      title: "Gen-AI Powered",
      description: "Advanced machine learning algorithms that adapt and evolve with your data needs"
    },
    {
      icon: <Cpu className="mb-4 text-blue-500" size={28} />,
      title: "Intelligent Data Mapping",
      description: "AI-driven transition from legacy systems to modern platforms like SAP S/4HANA,Microsoft Dynamics"
    },
    {
      icon: <Network className="mb-4 text-teal-500" size={28} />,
      title: "Predictive Analytics",
      description: "AI forecasting capabilities that transform raw data into actionable business insights"
    },
    {
      icon: <Code className="mb-4 text-indigo-500" size={28} />,
      title: "Automated Integration",
      description: "Self-learning systems that connect and optimize complex data ecosystems"
    },
    {
      icon: <Zap className="mb-4 text-amber-500" size={28} />,
      title: "Cognitive Automation",
      description: "Intelligent workflows that reduce manual effort and increase operational efficiency"
    },
    {
      icon: <RefreshCw className="mb-4 text-green-500" size={28} />,
      title: "Adaptive Governance",
      description: "AI-powered monitoring and compliance tools that evolve with regulatory changes"
    }
  ];

  // AI-themed animations
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimateParticles(prev => !prev);
    }, 8000);
    
    return () => clearInterval(interval);
  }, []);

  return (
     <div className="relative bg-gradient-to-b from-gray-900 via-gray-900 to-indigo-900 min-h-screen text-white overflow-hidden">
      <Header />
<div
  className="relative bg-gradient-to-b from-transparent via-blue-900 to-blue-900 min-h-screen text-white overflow-hidden"
  style={{ backgroundColor: 'rgba(58, 89, 209, 0.8)' }}
>
      <div className="absolute inset-0 overflow-hidden opacity-10">
        <div className="absolute w-full h-full">
          {Array.from({ length: 40 }).map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full bg-blue-500"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                width: `${Math.random() * 10 + 5}px`,
                height: `${Math.random() * 10 + 5}px`,
                opacity: Math.random() * 0.5 + 0.3,
                animation: `float ${Math.random() * 10 + 20}s linear infinite`,
                animationDelay: `${Math.random() * 20}s`,
                transform: animateParticles ? 'translateY(10px)' : 'translateY(-10px)',
                transition: 'transform 8s ease-in-out'
              }}
            />
          ))}
        </div>
        <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-gray-900 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-purple-900 to-transparent" />
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        {/* Header Section with AI Animation */}
        <div className="text-center mb-20 relative">
          <div className="inline-block relative mb-8">
            {/* <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-blue-500 rounded-full blur opacity-75 animate-pulse"></div> */}
            <h1 className="relative bg-gradient-to-r from-blue-200 to-purple-200 bg-clip-text text-transparent text-5xl font-bold py-2 px-4">About Us</h1>
          </div>
          
          <h2 className="text-3xl font-semibold mb-6 bg-gradient-to-r from-cyan-300 to-purple-300 bg-clip-text text-transparent">
            BlueGecko: Revolutionizing Data Management with AI
          </h2>
          <p className="text-xl text-blue-200">
            Powered by Nextgenlytics and GenAI 
          </p>
          
          {/* Animated AI Circuit Lines */}
          {/* <div className="absolute left-0 right-0 -bottom-6 h-12 flex justify-center">
            <div className="w-1 h-12 bg-gradient-to-b from-transparent via-blue-500 to-blue-300"></div>
          </div> */}
        </div>

        {/* Main Content with AI-themed Design */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          {/* Left Column: AI Visualization */}
          <div className="flex flex-col items-center justify-center">
            <div className="bg-gray-800 bg-opacity-50 p-8 rounded-2xl border border-blue-500 border-opacity-30 shadow-lg w-full mb-8 relative overflow-hidden">
              {/* Neural Network Animation */}
              {/* <div className="opacity-20">
                {Array.from({ length: 5 }).map((_, row) => (
                  <div key={`row-${row}`} className="flex justify-between">
                    {Array.from({ length: 5 }).map((_, col) => (
                      <div 
                        key={`node-${row}-${col}`} 
                        className="w-3 h-3 bg-blue-400 rounded-full"
                        style={{
                          position: 'absolute',
                          left: `${col * 25}%`,
                          top: `${row * 25}%`,
                          animation: `pulse ${Math.random() * 3 + 2}s infinite alternate`
                        }}
                      />
                    ))}
                  </div>
                ))}
              </div> */}
              
              {/* BlueGecko Logo/Name */}
              <div className="relative text-center">
<div className="flex items-center justify-center mb-6">
  <img 
    src={logo} 
    alt="Company Logo" 
    className="h-12 w-12 mr-3 object-contain" // Adjust size as needed
  />
<span className="text-5xl font-bold leading-tight bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
  Nextgenlytics
</span>
</div>

                <div className="mt-6 p-4 bg-gray-900 bg-opacity-50 rounded-xl inline-block">
                  <p className="text-lg font-light"><span className="text-blue-300">Founded:</span> Amsterdam, August 2022</p>
                  <p className="text-lg mt-2"><span className="text-blue-300">Experience:</span> <span className="text-purple-300 font-semibold">Two decades</span> of industry expertise</p>
                </div>
              </div>
            </div>
            
            {/* Tech Stats */}
            <div className="grid grid-cols-2 gap-4 w-full">
              <div className="bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-lg p-6 rounded-2xl border border-purple-500 border-opacity-30 text-center">
                <div className="text-4xl font-bold text-purple-300 mb-2">91%</div>
                <p className="text-blue-200">Data Accuracy</p>
              </div>
              <div className="bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-lg p-6 rounded-2xl border border-blue-500 border-opacity-30 text-center">
                <div className="text-4xl font-bold text-blue-300 mb-2">5x</div>
                <p className="text-blue-200">Faster Migration</p>
              </div>
            </div>
          </div>

          {/* Right Column: Company Description */}
          <div className="bg-gray-800 bg-opacity-40 backdrop-filter backdrop-blur-lg p-8 rounded-2xl border border-blue-500 border-opacity-30 shadow-lg relative">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-600 rounded-full filter blur-3xl opacity-10"></div>
            
            <h3 className="text-2xl font-semibold text-blue-300 mb-6 flex items-center">
              <Cpu className="mr-3" size={24} />
              Our AI-Powered Solution
            </h3>
            
            <p className="text-blue-100 mb-5 leading-relaxed">
              <span className="font-semibold text-purple-300">BlueGecko</span> is a cutting-edge AI product developed by 
              <span className="font-semibold text-purple-300"> Nextgenlytics</span>, combining decades of industry expertise with 
              state-of-the-art artificial intelligence to revolutionize data management.
            </p>
            
            <p className="text-blue-100 mb-5 leading-relaxed">
              Our intelligent system helps organizations seamlessly transition from legacy systems 
              to modern platforms like SAP S/4HANA and Oracle, using machine learning algorithms that
              <span className="text-purple-300"> adapt to your unique data ecosystem</span>.
            </p>
            
            <p className="text-blue-100 leading-relaxed">
              With BlueGecko's neural network-powered analytics, businesses can not only migrate their data
              but <span className="text-purple-300">transform it into actionable intelligence</span>. Our AI continuously 
              learns from your data patterns, providing increasingly sophisticated insights and optimizations
              over time.
            </p>
            
            {/* Tech Tags */}
            <div className="flex flex-wrap gap-2 mt-6">
              {['Neural Networks', 'Machine Learning', 'Predictive Analysis', 'NLP', 'Computer Vision'].map((tag, i) => (
                <span key={i} className="px-3 py-1 bg-blue-900 bg-opacity-50 rounded-full text-blue-200 text-sm">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* AI Feature Cards */}
        <h3 className="text-2xl font-bold text-center text-blue-200 mb-3">Our AI-Powered Solutions</h3>
        <p className="text-center text-blue-300 mb-10">Intelligent technologies delivering transformative results</p>
        
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 mb-20">
          {featureCards.map((card, index) => (
            <div 
              key={index}
              className="bg-gray-800 bg-opacity-40 backdrop-filter backdrop-blur-lg p-6 rounded-2xl border border-gray-700 shadow-lg transition-all duration-500 relative overflow-hidden"
              style={{
                transform: hoveredCard === index ? 'translateY(-10px)' : 'translateY(0)',
                boxShadow: hoveredCard === index ? '0 0 20px rgba(66, 153, 225, 0.3)' : 'none',
                borderColor: hoveredCard === index ? 'rgba(66, 153, 225, 0.5)' : 'rgba(55, 65, 81, 0.5)'
              }}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              {/* Animated gradient background on hover */}
              <div 
                className="absolute inset-0 bg-gradient-to-br opacity-0 transition-opacity duration-500" 
                style={{ 
                  opacity: hoveredCard === index ? 0.1 : 0,
                  background: 'linear-gradient(135deg, #3182ce 0%, #805ad5 100%)'
                }}
              />
              
              <div className="flex flex-col items-center text-center relative ">
                <div className="mb-4 p-3 rounded-full bg-gray-900 bg-opacity-50">
                  {card.icon}
                </div>
                <h4 className="text-xl font-semibold text-white mb-3">{card.title}</h4>
                <p className="text-blue-200">{card.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="relative bg-gray-800 bg-opacity-40 backdrop-filter backdrop-blur-lg rounded-2xl p-10 text-center border border-blue-500 border-opacity-30 overflow-hidden">
          {/* Animated circuit board lines */}
          <div className="absolute inset-0 opacity-10">
            <img src={about} alt="Home Icon"/>
          </div>
          
          <h3 className="text-3xl font-bold mb-4 relative bg-gradient-to-r from-blue-300 to-purple-300 bg-clip-text text-transparent">
            Ready to Experience AI-Powered Transformation?
          </h3>
          
          <p className="mb-8 text-lg text-blue-100 relative max-w-3xl mx-auto">
            BlueGecko's artificial intelligence transforms how businesses handle data migration and management,
            giving you an intelligent edge in your digital transformation journey.
          </p>

        <Link to="/">
          <button className="relative overflow-hidden group bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-500 hover:to-purple-500 text-white font-semibold py-4 px-10 rounded-lg transition-all duration-300">
            <span className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-blue-500 to-purple-500 group-hover:opacity-0 transition-opacity duration-300"></span>
            <span className="relative flex items-center">
              <span className="mr-2">Explore BlueGecko AI</span>
              <Zap size={20} className="animate-pulse" />
            </span>
          </button>
          </Link>
        </div>
      </div>
    </div>
    </div>
  );
}